import { useConnection } from "@solana/wallet-adapter-react";
import { useQuery } from "@tanstack/react-query";

import { useWalletInfo } from "../../contexts/WalletInfoContext";
import { QUERYKEYS } from "@utils/constants/queryKeys";
import { getDeposits } from "@utils/governance/vote-registry-deposits";

import { useRealmByPubkeyQuery } from "./useRealmByPubkeyQuery";
import { useVsrClient } from "./useVsrClient";

/**
 * For simplicity, it always fetches MNDE realm
 */
export const useDeposits = () => {
  const { connection } = useConnection();
  const { walletAddress } = useWalletInfo();
  const { data: vsrClient } = useVsrClient();
  const { data: realm } = useRealmByPubkeyQuery();

  const enabled = connection && walletAddress && realm && vsrClient;
  return useQuery({
    queryKey: enabled
      ? QUERYKEYS.getUserGovernanceDeposits(walletAddress.toString())
      : undefined,
    queryFn: async () => {
      if (!connection || !walletAddress || !realm || !vsrClient)
        throw new Error();
      const { deposits } = await getDeposits({
        isUsed: true,
        realmPk: realm.pubkey,
        walletPk: walletAddress,
        communityMintPk: realm.account.communityMint,
        client: vsrClient,
        connection,
      });
      return deposits;
    },
    cacheTime: 1 * 24 * 60 * 60 * 1000, // 1 day
    staleTime: 1 * 60 * 60 * 1000, // 1 hour
    enabled: Boolean(enabled),
  });
};
